import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameCardBase, GC_BASE_CSS } from '@/src/app/uygulamalar/hmi-pano/pano/game-card-base';

@Component({
  selector: 'siparis-kalemi-kart',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="gc gc--siparis-kalem" [style.--accent]="'#e65100'" [style.--accent-rgb]="'230,81,0'" (mousemove)="mouseMove($event)" (mouseleave)="mouseLeave()" [ngStyle]="kartStil">
      <div class="gc-canli-bg"></div><div class="gc-parlak-kenar"></div>
      <div class="gc-kose gc-kose--sol-ust"></div><div class="gc-kose gc-kose--sag-ust"></div><div class="gc-kose gc-kose--sol-alt"></div><div class="gc-kose gc-kose--sag-alt"></div>
      <div class="gc-kose-ic gc-kose-ic--sol-ust"></div><div class="gc-kose-ic gc-kose-ic--sag-ust"></div><div class="gc-kose-ic gc-kose-ic--sol-alt"></div><div class="gc-kose-ic gc-kose-ic--sag-alt"></div>
      <div class="gc-rarity-serit"></div><div class="gc-ic-glow"></div><div class="gc-desen"></div><div class="gc-shimmer"></div><div class="gc-holo"></div>
      <div class="gc-kenar-glow" [style.background]="kenarGlow"></div>
      <div class="gc-parcaciklar"><span class="gc-p gc-p--buyuk" style="--d:8s;--x:16%;--y:22%"></span><span class="gc-p" style="--d:11s;--x:74%;--y:38%"></span><span class="gc-p gc-p--kucuk" style="--d:6s;--x:50%;--y:72%"></span></div>
      <div class="gc-icerik">
        <div class="gc-hud-baslik">SİPARİŞ KALEMİ</div>
        <div class="sk-urun gc-baslik-ana">{{ p()?.urunAdi || 'Ürün' }}</div>
        <div class="sk-detay">
          <span class="sk-miktar">{{ p()?.miktar || 1 }} {{ p()?.birim || 'Adet' }}</span>
          <span class="sk-carpim">x</span>
          <span class="sk-fiyat">{{ birimFiyatFormatli() }}</span>
          @if (p()?.indirim > 0) { <span class="sk-indirim">-{{ p().indirim }}%</span> }
        </div>
        <div class="sk-toplam">{{ toplamFormatli() }}</div>
        <div class="gc-xp-bar"><div class="gc-xp-dolgu" [style.width.%]="gorunur() ? 70 : 0"></div></div>
      </div>
    </div>
  `,
  styles: [GC_BASE_CSS, `
    .gc { --accent: #e65100; --accent-rgb: 230,81,0; }
    .sk-urun { font-size: 13px; font-weight: 700; color: var(--py-metin, #e2e8f0); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .sk-detay { display: flex; align-items: center; gap: 6px; font-size: 10px; color: var(--py-metin-ikincil, #64748b); }
    .sk-miktar { font-weight: 600; }
    .sk-carpim { opacity: .5; }
    .sk-fiyat { font-variant-numeric: tabular-nums; }
    .sk-indirim { font-size: 9px; font-weight: 700; color: #ef4444; padding: 1px 4px; border-radius: 2px; background: rgba(239,68,68,.1); }
    .sk-toplam { font-size: 20px; font-weight: 900; color: #fbbf24; font-variant-numeric: tabular-nums; text-shadow: 0 0 12px rgba(251,191,36,.3); }
  `],
})
export class SiparisKalemiKartComponent extends GameCardBase {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});

  birimFiyatFormatli = computed(() => {
    const f = this.p()?.birimFiyat;
    if (f == null) return '0,00 ₺';
    return Number(f).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ₺';
  });

  toplamFormatli = computed(() => {
    const miktar = Number(this.p()?.miktar) || 1;
    const fiyat = Number(this.p()?.birimFiyat) || 0;
    const indirim = Number(this.p()?.indirim) || 0;
    const kdv = Number(this.p()?.kdv) || 20;
    let toplam = miktar * fiyat;
    if (indirim > 0) toplam *= (1 - indirim / 100);
    toplam *= (1 + kdv / 100);
    return toplam.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ₺';
  });
}
